import { ArrowRight, Check } from "lucide-react";
import { Link, useSearchParams } from "../app/router";
import { PageMeta } from "../components/PageMeta";
import { SectionHeading } from "../components/SectionHeading";
import { styles } from "../data/taxonomy";

export function StylesPage() {
  const [params] = useSearchParams();
  const selected = params.get("style");

  return (
    <>
      <PageMeta
        title="Ba nếp xanh | Rêu Nắng"
        description="Chọn thẩm mỹ khởi đầu cho ban công: nhiệt đới dịu, mộc ăn được hoặc tĩnh râm."
      />
      <section className="page-intro">
        <div className="container narrow">
          <span className="eyebrow">Thư viện cảm giác</span>
          <h1>Ba nếp xanh, ba cách sống cùng ban công.</h1>
          <p className="lead">
            Gu thẩm mỹ là điểm khởi đầu. Nắng, gió và công chăm mới quyết định bản phác cuối cùng.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="container style-stories">
          {styles.map((style, index) => (
            <article className={`style-story ${selected === style.id ? "is-selected" : ""}`} key={style.id}>
              <div className="story-media">
                <img src={style.image} width="1448" height="1086" alt={`Không gian ${style.name.toLowerCase()}`} />
                <span className="story-number">0{index + 1}</span>
              </div>
              <div className="story-copy">
                {selected === style.id && <span className="selected-badge"><Check size={15} /> Nếp đã chọn</span>}
                <span className="eyebrow">{style.ideal}</span>
                <h2>{style.name}</h2>
                <p>{style.description}</p>
                <dl className="story-meta">
                  <div><dt>Vật liệu</dt><dd>{style.materialTags.join(" · ")}</dd></div>
                  <div><dt>Tầng cây</dt><dd>{style.plantTags.join(" · ")}</dd></div>
                  <div><dt>Khoảng đầu tư</dt><dd>{style.budgetHint}</dd></div>
                </dl>
                <div className="palette large" aria-label={`Bảng màu ${style.name}`}>
                  {style.palette.map((color) => <i key={color} style={{ background: color }} />)}
                </div>
                <Link className="button button-secondary" to={`/thiet-ke?style=${style.id}`}>
                  Phác với nếp này <ArrowRight aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="section compare-section">
        <div className="container">
          <SectionHeading eyebrow="So sánh nhanh" title="Chọn theo việc bạn muốn làm ở ban công." />
          <div className="compare-grid">
            {styles.map((style) => (
              <article key={style.id}>
                <h3>{style.shortName}</h3>
                <p>{style.ideal}</p>
                <ul>
                  {style.materialTags.map((tag) => <li key={tag}><Check size={15} aria-hidden="true" /> {tag}</li>)}
                </ul>
                <strong>{style.budgetHint}</strong>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
